import { filter, withLatestFrom, mergeMap, debounceTime } from 'rxjs/operators';
import { Epic } from 'redux-observable';
import { getRelevantActionByFromLocationPath, getRoutingInfo } from '../utils';
import { routingOnRoute, routingOnRouteRequest } from '..';
import { RootState } from '../../../../store';

type IN = ReturnType<typeof routingOnRouteRequest>;
type OUT = ReturnType<typeof routingOnRoute>;

export const RoutingToRequestEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(routingOnRouteRequest.match),
    debounceTime(100),
    withLatestFrom(state$),
    mergeMap(([{ payload }, state]) => {
      const { fromLocation } = getRoutingInfo(payload);
      const actions$: OUT[] = [];

      actions$.push(
        getRelevantActionByFromLocationPath(fromLocation.path, payload),
      );

      return actions$;
    }),
  );
